/*
 * The javascript for validation, UI and clean up for the proposal
 * Author: Brad Mering
 * Last Mod: 12/01/2016
 */
var Proposal = {
    init: function () {
        // bind the functions to the dom
        this.bindDecline().bindView().checkWarn().bindChange().bindOther().bindSubmit();
        this.total();
        this.checkWarn();
    },
    data: {
        total: 0,
        decline: false,
    },
    warn: {},
    /**
     *
     */
    total: function () {
        var id,
            line,
            tax,
            val,
            total,
            amount,
            taxAmount = 0,
            view = this,
            totalTax = 0,
            total = 0;
        $('.option-selector').each(function (el) {
            // get line number
            var $target = $(this);
            id = $target.attr('line');
            val = $target.val();
            line = rates.pretax[id];
            tax = rates.linetaxable[id];
            // get line totals based on option
            switch (val) {
                case '-1': // custom quantity selected
                    view.warn[id] = true;
                    $('#other-' + id).show();
                    $target.next().hide();
                    var other = $('#other-' + id + ' input').val();
                    // Get the closest price estimate
                    amount = view.getClosest(other, id);
                    $('#total-' + id).html(currencySymbol + amount.format_commas());
                    if (tax) {
                        // if the line is taxable, multiple the rate against the total
                        // and add it to the tax line
                        taxAmount = amount * taxRate;
                        totalTax += taxAmount;
                        amount = amount + taxAmount;
                    }
                    total += amount;
                    break;
                case '0': // nothing selected
                    view.warn[id] = false;
                    amount = 0;
                    $('#total-' + id).html(currencySymbol + amount.format_commas());
                    break;
                default:
                    // they selected an actual version
                    view.warn[id] = false;
                    amount = line[val];
                    $('#total-' + id).html(currencySymbol + amount.format_commas());
                    if (tax) {
                        // if the line is taxable, multiple the rate against the total
                        // and add it to the tax line
                        taxAmount = amount * taxRate;
                        totalTax += taxAmount;
                        amount = amount + taxAmount;
                    }
                    total += amount;
                    break;
            }

            if (rates.taxable) $('#taxAmount').text(currencySymbol + totalTax.format_commas());
            $('#total').text(currencySymbol + total.format_commas());
            view.data.total = total;
        });
        return this;
    },

    // Get the closest quantity that is less than the number they typed
    getClosest: function (other, id) {
        // get quantities array
        var quantities = rates.quantities[id],
            found = 0,
            minimum = false,
            tmp = {},
            foundV = false,
            minV = false;
        $.each(quantities, function (version, quantity) {
            if (version !== 0) {
                // Find the lowest value
                if (!minimum) {
                    minimum = quantity;
                    minV = version;
                } else {
                    if (minimum > quantity) {
                        minimum = quantity;
                        minV = version;
                    }
                }

                // if other is greater than this quantity and this quantity is greater
                // than our current found quantity,
                if (other > quantity && quantity > found) {
                    found = quantity;
                    foundV = version;
                }
            }
        });
        if (found == 0 || !rates.pretax[id][foundV]) {
            found = minimum; // fall back on the minimum if we didn't find something
            foundV = minV;
        }
        // get prices from foundV
        var pretax = rates.pretax[id][foundV];
        if (pretax) {
            // Calculate a rate for this quantity
            var rate = pretax / found;
            return other * rate;
        }
        return 0;
    },

    bindSubmit: function (e) {
        var view = this;
        $('#approval-form form').on('submit', function (e) {
            if (!view.data.decline) {
                if (view.data.total > 0) {
                    return true;
                }
                new Noty({
                    theme: 'light',
                    layout: 'center',
                    type: 'error',
                    text: 'Please select at least one option.',
                    timeout: 5000,
                }).show();
                return false;
            }
        });
    },

    bindChange: function () {
        var view = this;
        $('.option-selector').change(function (e) {
            view.total().checkWarn();
        });
        $('.other-quantity input').blur(function (e) {
            view.total().checkWarn();
        });
        return this;
    },

    bindOther: function () {
        $('.other-quantity .other-toggle').click(function () {
            var $target = $(this),
                id = $target.attr('line');
            $('#other-' + id)
                .hide()
                .val('');
            $('#quantity-' + id)
                .val(0)
                .trigger('change');
            $('.line-' + id + ' .select2').show();
        });
        return this;
    },

    //
    checkWarn: function () {
        var isWarn = false;
        $.each(this.warn, function (i, w) {
            if (w) {
                isWarn = true;
                return false;
            }
        });

        if (isWarn) {
            var warning =
                'You entered a quantity that was not on the original Project Proposal. An estimate for the new quantity was automatically generated based on the unit cost at one of the original quantities. The new estimate may not be accurate. <br/><br/> <center>Please consider the price a non-binding estimate.</center>';
            $('.warning')
                .html(
                    '<div class="alert alert-error "><i class="fa fa-3x fa-exclamation-triangle pull-left" aria-hidden="true"></i>' +
                        warning +
                        '</div>'
                )
                .slideDown();
            $('.sign-warn').show();
        } else {
            $('.warning').html('').hide();
            $('.sign-warn').hide();
        }
        return this;
    },

    // Bind the decline button to change the button label
    bindDecline: function () {
        var poRequired = $('#po input').attr('required'),
            costCodeRequired = $('#costcode input').attr('required'),
            view = this;
        $('#decline').change(function () {
            if (this.checked) {
                $('#SubmitButton').val('Decline Proposal');
                $('#po').hide();
                $('#costcode').hide();
                $('#po input').attr('required', false);
                $('#costcode input').attr('required', false);
                view.data.decline = true;
            } else {
                $('#SubmitButton').val('Approve Proposal');
                $('#po').show();
                $('#costcode').show();
                $('#po input').attr('required', poRequired);
                $('#costcode input').attr('required', costCodeRequired);
                view.data.decline = false;
            }
        });
        return this;
    },

    // Bind the proposal view button to show the proposal
    bindView: function () {
        // Allow users to toggle open the full proposal
        var i = false;
        $('#project-toggle a').click(function (e) {
            e.preventDefault();
            if (!i) {
                $('#project-toggle a').text('Hide Proposal');
                i = true;
            } else {
                $('#project-toggle a').text('Show Proposal');
                i = false;
            }
            $('#project-body').slideToggle();
            return false;
        });
        return this;
    },

    // Allow Toggling of Email Message Generator
    bindFollowup: function () {
        var message = false;
        $('#message-main h3').click(function () {
            if (!message) {
                $('#message-main h3').text('Hide Follow-up Message');
                message = true;
            } else {
                $('#message-main h3').text('Create Follow-up message');
                message = false;
            }
            $('#add-notes').slideToggle();
        });
        return this;
    },
};

P3Portal.boot.push(Proposal);
